<section id="montreal-faca-as-contas" *ngIf="planos.length">
    <div class="container is-fullhd">
        <div class="columns">
            <div class="column is-offset-1 is-5" id="area-text-contas">
                <h1>Faça as contas</h1>

                <h5>Plano {{categoriaTituloDescritivo()}}</h5>
                <p *ngIf="text1" [innerHTML]="text1"></p>
                <br>
                <a *ngIf="!isMobile" class="btn btn-primary" (click)="persistirProposta()">Faça sua assinatura</a>
                <br>
                <a *ngIf="!isMobile" href="/contatos" class="link-call"><i class="fas fa-comment"></i> Ainda em dúvida? Fale com a gente</a>

            </div>
            <div class="column  is-5" id="area-table">

                <div class="area-table-fake">

                    <div class="lista-valores-head">
                        <div class="item"><strong>Diárias</strong></div>
                        <div class="item"><strong>Parcela</strong>/mês</div>
                        <div class="item"><strong>Total</strong>/Ano</div>
                    </div>

                    <div class="area-select select-pessoas">
                        <i class="fas fa-user-plus"></i>
                        <select [ngModel]="selectedTypeValue" (ngModelChange)="onChangeType($event)">
                            <option [value]="i.value" *ngFor="let i of typeValues">{{i.label}}</option>
                        </select>
                        <i class="fas fa-chevron-down"></i>
                    </div>

                    <div class="area-select select-plano">
                        <select [ngModel]="selectedCategoria" (ngModelChange)="onChangeCategoria($event)">
                            <option *ngFor="let item of planos" value="{{item.codigoCategoria}}">
                                {{item.descricao}}
                            </option>
                        </select>
                        <i class="fas fa-chevron-down"></i>
                    </div>
                    <div style="height: 400px; overflow: auto;">
                        <div class="lista-valores" *ngFor="let item of valoresPlanoList"
                             [ngClass]="{'destaque': item.destaque == true }">
                            <div class="item-list">{{item.quantidade_diarias}}</div>
                            <div class="item-list">{{item.valor}}</div>
                            <div class="item-list">{{item.totalAno}}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="column is-offset-1 is-5" id="area-text-action">
                <a *ngIf="isMobile" href="/contatos" class="link-call"><i class="fas fa-comment"></i> Ainda em dúvida? Fale com a gente</a>
                <a *ngIf="isMobile" class="btn btn-primary link-action" (click)="persistirProposta()">Faça sua assinatura</a>
            </div>

        </div>
    </div>
</section>
